import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { fmtMoney } from "@/shop/shopApi";
import { easeOutExpo } from "@/shop/motion";

export default function ProductCard({ product, index = 0 }) {
  const p = product;
  const soldOut = p.available === false;
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, ease: easeOutExpo, delay: (index % 4) * 0.06 }}
    >
      <Link to={`/shop/product/${p.handle}`} className="group block" data-testid={`product-card-${p.handle}`}>
        <div className="relative aspect-[4/5] overflow-hidden rounded-2xl bg-[#161619]">
          {p.featured_image ? (
            <img
              src={p.featured_image}
              alt={p.title}
              loading="lazy"
              className="w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105"
            />
          ) : (
            <div className="w-full h-full grid place-items-center text-white/20 text-xs">No image</div>
          )}
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
          {soldOut && (
            <span className="absolute top-3 left-3 text-[10px] uppercase tracking-[0.2em] bg-black/70 backdrop-blur px-3 py-1.5 rounded-full text-white/80">Sold out</span>
          )}
          <span className="absolute bottom-3 left-3 right-3 translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
            <span className="block w-full text-center text-[13px] font-medium bg-white text-black rounded-full py-3">View product</span>
          </span>
        </div>
        <div className="mt-4 flex items-start justify-between gap-3">
          <div className="min-w-0">
            <h3 className="text-[15px] font-medium leading-tight truncate group-hover:text-[#3b9bff] transition-colors">{p.title}</h3>
            {p.product_type && <p className="text-xs text-white/45 mt-1">{p.product_type}</p>}
          </div>
          <p className="text-[15px] font-semibold whitespace-nowrap">{fmtMoney(p.price)}</p>
        </div>
      </Link>
    </motion.div>
  );
}
